import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import TPHero from "./components/TPHero";
import TPContent from "./components/TPContent";
import TPShopSection from "./components/TPShopSection";
import TPFormula from "./components/TPFormula";
import TPRelated from "./components/TPRelated";
import TPBottomCTA from "./components/TPBottomCTA";

export default function BeigeThrowPillowsPage() {
  return (
    <div className="min-h-screen bg-[#FDFAF5]" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Navbar />
      <main>
        <TPHero />
        <div className="max-w-screen-xl mx-auto px-8 md:px-16">
          <TPContent />
          <TPShopSection />
          <TPFormula />
        </div>
        <TPRelated />
        <TPBottomCTA />
      </main>
      <Footer />
    </div>
  );
}
